module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"work_count":"Work count","all":"All types","work_type_filter":"Work type filter"},"cs":{"work_count":"Počet děl","all":"Všechny typy","work_type_filter":"Filtr podle typu díla"}}')
  delete Component.options._Ctor
}
